/**
 * Hook to detect desktop web environment and responsive breakpoints
 */
import { useState, useEffect } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import { DesktopTheme } from '../theme/desktopTheme';

export const useDesktopDetect = () => {
  const { width, height } = useWindowDimensions();
  const [isHoverable, setIsHoverable] = useState(false);

  useEffect(() => {
    // Check if device supports hover (desktop vs touch)
    if (Platform.OS === 'web') {
      const mediaQuery = window.matchMedia('(hover: hover)');
      setIsHoverable(mediaQuery.matches);

      const handler = (e) => setIsHoverable(e.matches);
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
    }
  }, []);

  const isWeb = Platform.OS === 'web';
  const { breakpoints } = DesktopTheme;

  return {
    // Platform checks
    isWeb,
    isNative: !isWeb,

    // Responsive breakpoints
    isMobile: width < breakpoints.tablet,
    isTablet: width >= breakpoints.tablet && width < breakpoints.desktop,
    isDesktop: width >= breakpoints.desktop,
    isWide: width >= breakpoints.wide,

    // Combined checks
    isDesktopWeb: isWeb && width >= breakpoints.desktop,
    isTabletOrDesktop: width >= breakpoints.tablet,
    isMobileOrTablet: width < breakpoints.desktop,

    // Interaction capability
    isHoverable,
    supportsHover: isWeb && isHoverable,

    // Dimensions
    width,
    height,

    // Sidebar visibility
    shouldShowSidebar: isWeb && width >= breakpoints.desktop,
    shouldCollapseSidebar: isWeb && width >= breakpoints.tablet && width < breakpoints.desktop,
  };
};

export default useDesktopDetect;
